import Input from "./input"

export default {
  variants: Input.variants,
}
